import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacingMixin } from '@zillow/constellation';
import responsiveContainerMixin from '../../themes/components/ResponsiveContainer';

/**
 * A responsive container create to replace the `Container` component from multibrand UI
 * https://bitbucket.hotterpads.com/projects/RP/repos/multibrand-ui/browse/src/components/Container/Container.js
 * To be primarily used with comet applications (Payments, Leases, Renter Hub, ZRM, etc)
 */

const ResponsiveContainer = styled.div`
  ${responsiveContainerMixin}
  & {
    ${(props) => props.theme && props.theme.ns && spacingMixin}
  }
`;

ResponsiveContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fluid: PropTypes.bool,
  fluidMobile: PropTypes.bool,
  maxWidth: PropTypes.string,
};

ResponsiveContainer.defaultProps = {
  fluid: false,
  fluidMobile: false,
  maxWidth: '1280px',
};

/** @component */
export default ResponsiveContainer;
